<template>
  <basic-dialog :show="show" @close="$emit('close')" max-width="900">
    <template v-slot:title>{{ title }}</template>
    <v-row>
      <v-col>
        <v-combobox
          v-if="recipientsList.length > 0"
          :label="emailToLabel"
          v-model="emailTo"
          item-text="label"
          item-value="value"
          :items="recipientsList"
          :outlined="outlinedInputs"
          hide-details
          :multiple="multiple"
          :return-object="multiple"
        >
        </v-combobox>
        <v-text-field
          v-else
          :label="emailToLabel"
          v-model="emailTo"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>

      <v-col>
        <email-types-list-select
          @select="onEmailTypeSelect"
          :outlined="outlinedInputs"
          v-model="emailType"
          hide-details
        ></email-types-list-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-text-field
          label="Subject"
          v-model="subject"
          :outlined="outlinedInputs"
          hide-details
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-select
          v-if="attachmentList.length > 0 && false"
          label="Attach Link"
          v-model="attachedLink"
          :items="attachmentList"
          item-text="name"
          item-value="code"
          :outlined="outlinedInputs"
          clearable
          hide-details
          @change="onAttachLinkChange"
        >
        </v-select>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-textarea
          v-if="false"
          outline
          label="Message"
          rows="8"
          v-model="message"
          :outlined="outlinedInputs"
          hide-details
        ></v-textarea>
        <vue-editor v-model="message" />
      </v-col>
    </v-row>
    <v-row>
      <v-col class="py-0">
        <v-container fluid>
          <v-row justify="center">
            <v-checkbox
              v-model="cc"
              label="CC to:"
              hide-details
              class="mr-2"
            ></v-checkbox>
            <v-text-field
              v-model="ccTo"
              label="Email"
              :disabled="!cc"
              :outlined="outlinedInputs"
              hide-details
            ></v-text-field>
          </v-row>
        </v-container>
      </v-col>
    </v-row>
    <template v-slot:actions>
      <v-menu offset-y v-if="attachmentList.length > 0">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on"> Attach Link to Form </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(item, index) in userExternalForms"
            :key="index"
            @click="onFormSelect(item.code)"
          >
            <v-list-item-title>{{ item.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn color="primary" @click="onSend" :disabled="!isValid">Send</v-btn>
    </template>
    <div v-if="debug">
      <code>{{ userExternalForms }}</code>
    </div>
    <external-form-dialog
      :show="showFormDetails"
      v-model="selectedForm"
      @close="showFormDetails = false"
      :itinerary="itinerary"
      @attachLink="onAttachLink"
      show-attach-link
    />
  </basic-dialog>
</template>

<script>
import gql from "graphql-tag";
import BasicDialog from "./BasicDialog";
import EmailTypesListSelect from "./EmailTypesListSelect.vue";
import { VueEditor } from "vue2-editor";
import ExternalFormDialog from "./external-forms/ExternalFormDialog.vue";
const EXTERNAL_FORMS_LIST_QUERY = gql`
  query userExternalForms {
    userExternalForms {
      name
      code
      description
      isPaymentAmountRequired
    }
  }
`;
export default {
  name: "email-dialog",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
    title: {
      type: String,
      default: () => "Send Email",
    },
    itinerary: {
      type: Object,
      default: () => null,
    },
  },

  components: {
    BasicDialog,
    EmailTypesListSelect,
    VueEditor,
    ExternalFormDialog,
  },

  data() {
    return {
      debug: false,
      cc: this.value && this.value.ccTo && this.value.ccTo != "",
      attachedLink: this.value ? this.value.attachedLink : "",
      emailTo: this.value
        ? this.value.multiple
          ? [this.value.recipients[0]]
          : this.value.emailTo
        : "",
      subject: this.value ? this.value.subject : "",
      message: this.value ? this.value.message : "",
      ccTo: this.value ? this.value.ccTo : "",
      shareLink: this.value ? this.value.shareLink : "",
      emailType: null,
      multiple: this.value && this.value.multiple ? this.value.multiple : false,
      selectedForm: null,
      showFormDetails: false,
    };
  },

  computed: {
    attachmentList() {
      return this.userExternalForms ? this.userExternalForms : [];
    },
    recipientsList() {
      return this.value && this.value.recipients
        ? [...this.value.recipients]
        : [];
    },
    emailToLabel() {
      return this.value && this.value.emailToLabel
        ? this.value.emailToLabel
        : "Email";
    },
    isValid() {
      return this.emailTo != "" && this.subject != "" && this.message != "";
    },
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
  },

  watch: {
    value(newValue) {
      this.emailTo = newValue.multiple
        ? [newValue.recipients[0]]
        : newValue.emailTo
        ? newValue.emailTo
        : "";
      this.cc = false; //newValue && newValue.ccTo != "";
      this.ccTo = newValue.ccTo ? newValue.ccTo : "";
      this.subject = newValue.subject ? newValue.subject : "";
      this.message = newValue.message ? newValue.message : "";
      this.attachedLink = newValue.attachedLink ? newValue.attachedLink : "";
      this.shareLink = newValue.shareLink ? newValue.shareLink : "";
      this.multiple = newValue.multiple ? newValue.multiple : false;
    },
  },

  methods: {
    onEmailTypeSelect(payload) {
      this.subject = payload.subject;
      this.message =
        this.shareLink && this.shareLink != ""
          ? `${payload.template}\n ${this.shareLink}`
          : payload.template;
    },
    onSend() {
      this.$emit("send", {
        attachedLink: this.attachedLink,
        emailTo: Array.isArray(this.emailTo)
          ? this.emailTo.map((e) => e.value).join(",")
          : this.emailTo,
        ccTo: this.cc ? this.ccTo : "",
        subject: this.subject,
        message: this.message,
      });
    },
    onFormSelect(code) {
      const selectedForm = this.userExternalForms.find((e) => e.code == code);
      if (selectedForm) {
        this.selectedForm = { ...selectedForm };
        this.showFormDetails = true;
      }
    },
    onAttachLink(linkURL) {
      this.showFormDetails = false;
      this.message = `${this.message}\n <a href="${linkURL}">${linkURL}</a>`;
    },
  },

  apollo: {
    userExternalForms: {
      query: EXTERNAL_FORMS_LIST_QUERY,
      fetchPolicy: "network-only",
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/EmailDialog.vue